// in src/App.js
import React from 'react';
import { Admin, Resource } from 'react-admin';
import jsonServerProvider from 'ra-data-json-server';

import FeedList from './pages/lists/Feed';
import HudList from './pages/lists/Hud';
import { JourneyList } from './pages/lists/Journeys';
import { SettingsList } from './pages/lists/Settings';
import { PagesList } from './pages/lists/Pages';
import { ContactList } from './pages/lists/Contacts';
import {PageEdit} from './pages/edit/Page';

import DashboardIcon from '@material-ui/icons/Dashboard';
// import HomeIcon from '@material-ui/icons/Home';
import SettingsIcon from '@material-ui/icons/Settings';
import JourneyIcon from '@material-ui/icons/NaturePeople';
import PageIcon from '@material-ui/icons/LibraryBooks';
import ContactIcon from '@material-ui/icons/PersonPinCircle';
import HomeIcon from '@material-ui/icons/Home';
import GradeIcon from '@material-ui/icons/Grade';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PlaceIcon from '@material-ui/icons/Place';
import Badge from '@material-ui/core/Badge';

import InsightDetailRouter from './pages/details/InsightDetailRouter';

import { createMuiTheme } from '@material-ui/core/styles';
import {
    cyan500, cyan700,
    pinkA200,
    grey100, grey300, grey400, grey500,
    white, darkBlack, fullBlack,
} from '@material-ui/core/colors';
import spacing from '@material-ui/core/styles/spacing';

const altolaTheme = createMuiTheme({
    spacing: spacing,
    fontFamily: 'Roboto, sans-serif',
    appBar: {
        color: darkBlack,
        height: 10,
    },
});

const dataProvider = jsonServerProvider(process.env.REACT_APP_API_HOST);

const activityIcon = <Badge badgeContent={4} color="primary">
                        <HomeIcon />
                    </Badge>;
const App = () =>
    <Admin theme={altolaTheme} title="AI Insights" dataProvider={dataProvider}>
        <Resource name="feed" list={FeedList} icon={HomeIcon} options={{ label: 'Feed' }} />
        <Resource name="insights" list={HudList} show={InsightDetailRouter} icon={PlaceIcon} options={{ label: 'Pinned Insights' }} />
        <Resource name="journeys" list={JourneyList} show={InsightDetailRouter} icon={JourneyIcon} options={{ label: 'Journey Analyzer' }} />
        <Resource name="contacts" list={ContactList} show={InsightDetailRouter} icon={ContactIcon} options={{ label: 'Contact Explorer' }} />
        <Resource name="pages" list={PagesList} edit={PageEdit} show={InsightDetailRouter} icon={PageIcon} options={{ label: 'Content Analytics' }} />
        <Resource name="settings" list={SettingsList} show={InsightDetailRouter} icon={SettingsIcon} options={{ label: 'Settings' }} />
    </Admin>

export default App;


// WEBPACK FOOTER //
// ./src/App.js